module.exports = __webpack_public_path__ + "static/media/7.d8d047b8.png";